module.exports = __webpack_public_path__ + "static/media/bycycle.cfc92780.svg";